import {ProductPackageFormField} from "../types/product-package-modal.types";
import {Validators} from "@angular/forms";

export const productPackageFormFields: Array<ProductPackageFormField> = [
  {
    fieldName: 'packageName',
    label: 'Название',
    type: 'text',
    rowKey: 'packageName',
    validators: [Validators.required]
  },
  {
    fieldName: 'length',
    label: 'Длина',
    rowKey: 'size',
    type: 'number',
    decimals: 1,
    matTextSuffixValue: 'см',
    validators: [ Validators.min(0) ]
  },
  {
    fieldName: 'width',
    label: 'Ширина',
    rowKey: 'size',
    type: 'number',
    decimals: 1,
    matTextSuffixValue: 'см',
    validators: [ Validators.min(0) ]

  },
  {
    fieldName: 'height',
    label: 'Высота',
    rowKey: 'size',
    type: 'number',
    decimals: 1,
    matTextSuffixValue: 'см',
    validators: [ Validators.min(0) ]
  },
  {
    fieldName: 'weight',
    label: 'Вес',
    rowKey: 'size',
    type: 'number',
    decimals: 2,
    matTextSuffixValue: 'кг',
    validators: [ Validators.min(0) ]
  },
  {
    fieldName: 'quantity',
    label: 'Кол-во',
    rowKey: 'size',
    type: 'number',
    validators: [ Validators.min(0) ]
  },
  {
    fieldName: 'packageType',
    label: 'Тип упаковки продукта',
    rowKey: 'packageType',
    type: 'select',
    validators: [Validators.required]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    rowKey: 'comment',
    type: 'textarea'
  },
  {
    fieldName: 'storageLocationType',
    label: 'Площадки',
    rowKey: 'location',
    type: 'select'
  },
  {
    fieldName: 'nmId',
    label: 'Артикул WB',
    rowKey: 'articles',
    type: 'select'
  },
  {
    fieldName: 'sku',
    label: 'Артикул Ozon',
    rowKey: 'articles',
    type: 'select'
  }
]
